/**
 * Campos padrão do lead (não inclui campos extras de contact.others).
 * Os extras são obtidos dinamicamente via getExtraFields(contact.others).
 * O admin configura quais extras ficam visíveis e o rótulo de cada um
 * (ex.: LOJA_DE_PREFERENCIA → "Loja de Preferência").
 */

export interface LeadFieldDefinition {
  id: string;
  label: string;
}

/* ============================================================
   CAMPOS PADRÃO (LeadContact)
============================================================ */

export const LEAD_VISIBLE_FIELD_OPTIONS = [
  { id: "fixed", label: "Lead alterado" },
  { id: "campaign_name", label: "Campanha" },
  { id: "store", label: "Loja" },
  { id: "status", label: "Status" },
  { id: "client_name", label: "Cliente" },
  { id: "lead_id", label: "ID do Lead" },
  { id: "telephone", label: "Telefone" },
  { id: "other_contacts", label: "Outros contatos" },
  { id: "attendant_name", label: "Atendente" },
  { id: "coordinator_name", label: "Coordenador" },
  { id: "vehicle", label: "Veículo de interesse" },
  { id: "vehicle_exchange", label: "Veículo para troca" },
  { id: "vehicle_financing", label: "Pretende financiar" },
  { id: "vehicle_estimated_purchase", label: "Previsão de compra" },
  { id: "scheduled_date", label: "Data agendada" },
  { id: "call_back_date", label: "Data de retorno" },
  { id: "note", label: "Observações" },
] as const;

/**
 * Union automática dos IDs
 * Ex: "fixed" | "campaign_name" | ...
 */
export type LeadVisibleFieldId =
  (typeof LEAD_VISIBLE_FIELD_OPTIONS)[number]["id"];

/* ============================================================
   CAMPOS DE QUALIDADE (leads_quality)
============================================================ */

export const LEAD_QUALITY_FIELD_OPTIONS = [
  { id: "store_contact", label: "Recebeu contato do consultor?" },
  { id: "store_visit", label: "Compareceu ao evento?" },
  { id: "store_buy", label: "Comprou na concessionária?" },
  { id: "store_buy_locale", label: "Onde comprou?" },
  { id: "store_buy_motive", label: "Qual motivo de não ter comprado?" },
  { id: "store_status", label: "Status Qualidade" },
  { id: "new_scheduled_date", label: "Nova data do agendamento" },
  { id: "new_call_back_date", label: "Retornar a ligação em" },
] as const;

/**
 * Union automática dos IDs de qualidade
 */
export type LeadQualityFieldId =
  (typeof LEAD_QUALITY_FIELD_OPTIONS)[number]["id"];

/* ============================================================
   UTILITÁRIO PARA GERAR DEFAULTS
============================================================ */

function buildFieldConfig<T extends readonly { id: string; label: string }[]>(
  options: T,
) {
  const ids = options.map((f) => f.id);

  const labels = Object.fromEntries(
    options.map((f) => [f.id, f.label]),
  ) as Record<T[number]["id"], string>;

  return { ids, labels };
}

/* ============================================================
   DEFAULTS PADRÃO
============================================================ */

export const { ids: DEFAULT_VISIBLE_FIELD_IDS, labels: DEFAULT_FIELD_LABELS } =
  buildFieldConfig(LEAD_VISIBLE_FIELD_OPTIONS);

export const {
  ids: DEFAULT_QUALITY_VISIBLE_FIELD_IDS,
  labels: DEFAULT_QUALITY_FIELD_LABELS,
} = buildFieldConfig(LEAD_QUALITY_FIELD_OPTIONS);
